import React, { createContext, useState, useCallback } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export const UserContext = createContext();

// 전체 유저 정보 상태 저장
export const UserProvider = ({ children }) => {
  const [allUsers, setAllUsers] = useState([]);
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [usersCache, setUsersCache] = useState(new Map());

  // 특정 유저들만 가져오기 (캐싱 포함)
  const getUsersByIds = useCallback(async (userIds) => {
    if (!userIds || userIds.length === 0) return [];
    
    const uncachedIds = userIds.filter(id => !usersCache.has(id));
    
    if (uncachedIds.length > 0) {
      try {
        const q = query(collection(db, 'users'), where('__name__', 'in', uncachedIds));
        const snapshot = await getDocs(q);
        
        const newCache = new Map(usersCache);
        snapshot.docs.forEach(doc => {
          const userData = {
            uid: doc.id,
            name: doc.data().name || 'No Name',
            picture: doc.data().picture || '',
          };
          newCache.set(doc.id, userData);
        });
        
        setUsersCache(newCache);
      } catch (error) {
        // Error fetching users
      }
    }
    
    return userIds.map(id => usersCache.get(id)).filter(Boolean);
  }, [usersCache]);

  // 필요한 경우에만 전체 유저 로드
  const loadAllUsers = useCallback(async () => {
    if (isUserLoading || allUsers.length > 0) return;
    
    setIsUserLoading(true);
    try {
      const snapshot = await getDocs(collection(db, 'users'));
      const users = snapshot.docs.map((doc) => ({
        uid: doc.id,
        name: doc.data().name || 'No Name',
        picture: doc.data().picture || '',
      }));
      setAllUsers(users);
    } catch (error) {
      // Error fetching all users
    } finally {
      setIsUserLoading(false);
    }
  }, [isUserLoading, allUsers.length]);

  return (
    <UserContext.Provider value={{ 
      allUsers, 
      isUserLoading, 
      getUsersByIds, 
      loadAllUsers,
      usersCache 
    }}>
      {children}
    </UserContext.Provider>
  );
};